import { generateMarketPathname, InternationalMarket } from '@chewy/market-handler';
import { IncomingHttpHeaders } from 'http';

import { Configuration, ContentApi } from '@/generated-client/content-a';
import { getAuthenticatedAxios } from '@/services/network/authenticated-axios';

export const createContentApi = (market: string, headers?: IncomingHttpHeaders) => {
  const contentHeaders = { ...headers };

  // The inbound Host header belongs to loyalty-ui, not the external content host.
  // Forwarding it causes Akamai to reject otherwise valid content requests.
  delete contentHeaders.host;

  const isCredentialedContentPath = market.includes(InternationalMarket.enUS);
  // Only the US content path is credentialed here; non-US content keeps the existing transport.
  const baseOptions = isCredentialedContentPath
    ? {
        headers: contentHeaders,
        withCredentials: true,
      }
    : {};

  return new ContentApi(
    new Configuration({
      baseOptions,
      basePath: String(
        process.env.CHEWY_BASE_URL
          ? `${process.env.CHEWY_BASE_URL}/api/content`
          : typeof window !== 'undefined' &&
              `${window.location.origin}${generateMarketPathname('/api/content', market)}`,
      ),
    }),
    undefined,
    isCredentialedContentPath ? getAuthenticatedAxios() : undefined,
  );
};
